module.exports = __webpack_public_path__ + "media/bootstrap-icons/toggle-on-48413808.svg";